import fr from 'facet-rest';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { dataAttrs } from 'Helpers/Testing';
import React from 'react';
import useMobileLayout from 'Hooks/useMobileLayout';
import useBoneBackgroundColor from 'Hooks/useBoneBackgroundColor';
import {
  FDAvatar, FDContentContainer, FDSecondaryActionButton, FDStack,
} from '@facet-wealth/design';
import { noop } from 'Helpers/PropTypes';
import useEventTrackingLogEvent, { categories, eventSubTypes, eventTypes } from 'EventTracking/useEventTrackingLogEvent';

export const RequestConfirmation = ({ resource, onClick = noop, loading = false }) => {
  const isMobile = useMobileLayout();
  const { logStandardizedEvent } = useEventTrackingLogEvent();

  useBoneBackgroundColor();
  return (
    <FDContentContainer maxWidth={'md'}>
      <FDStack direction={'column'} spacing={isMobile ? 2 : 3} flex={1} width={'100%'} paddingY={4}>
        <FDStack direction={'column'} spacing={3} alignItems={'center'} justifyContent={'center'}>
          {resource.withRelationship(fr.relationships.avatar.name,
            (rel) => (
              <FDAvatar
                size={rel.meta('avatarSize')}
                src={rel.link('related').url()}
                alt={rel.meta('altText') || ''}
              />),
            () => null)}
          <MetaControlField attr={'title'} {...dataAttrs('upgrade confirmation title')} />
          <MetaControlField attr={'description'} {...dataAttrs('upgrade confirmation description')} />
        </FDStack>
        {resource.withRelationship(fr.relationships.clientDashboard.name, (rel) => (
          <FDStack direction={'column'} alignItems={'center'} justifyContent={'center'}>
            <FDSecondaryActionButton
              loading={loading}
              label={rel.meta('prompt')}
              onClick={() => {
                logStandardizedEvent(categories.upgrade, eventTypes.page, eventSubTypes.clickedCTA, {
                  eventProperties: {
                    householdId: resource.attr('householdId'),
                    action: 'client-dashboard',
                  },
                });
                onClick(rel);
              }}
              {...dataAttrs('navigate to dashboard btn')}
            />
          </FDStack>
        ), () => null)}
        {resource.withRelationship(fr.relationships.pricingPage.name, (rel) => (
          <FDStack direction={'column'} alignItems={'center'} justifyContent={'center'}>
            <FDSecondaryActionButton
              loading={loading}
              label={rel.meta('prompt')}
              onClick={() => {
                logStandardizedEvent(categories.upgrade, eventTypes.page, eventSubTypes.clickedCTA, {
                  eventProperties: {
                    householdId: resource.attr('householdId'),
                    action: 'pricing-page',
                  },
                });
              }}
              href={rel.link('related').url()}
              {...dataAttrs('navigate to pricing page btn')}
            />
          </FDStack>
        ), () => null)}
      </FDStack>
    </FDContentContainer>
  );
};
